import React from 'react';

import { InterventionPlanification } from 'components';

export const PageInterventionPlanification = () => (
  <InterventionPlanification />
);
